
import { i18nText } from '@/locales';

import {Component, Vue} from 'vue-property-decorator';
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {ITableColumn} from "@/entity/table/table.types";
import {TablesStore} from "@/store/modules/Tables";
import CounterpartiesAddForm from "@/form/finance/counterparties/CounterpartiesAddForm";
import CounterpartiesUpdateForm from "@/form/finance/counterparties/CounterpartiesUpdateForm";
import CounterpartiesAddComponent from "@/UI/components/forms/finance/counterparties/CounterpartiesAddComponent.vue";
import CounterpartiesUpdateComponent
  from "@/UI/components/forms/finance/counterparties/CounterpartiesUpdateComponent.vue";
import {CounterpartiesStore} from "@/store/modules/Counterparties";
import {CounterpartiesTypeStore} from "@/store/modules/CounterpartiesType";
import ModalWrapper from "@/UI/components/common/ModalWrapper.vue";
import {ICounterpartiesListItem} from "@/entity/finance/counterparties/counterparties.types";
import {
  ICounterpartiesType,
} from "@/entity/finance/counterparties/counterpartiesType.types";
import {mixins} from 'vue-class-component'
import {ProxyDataForm} from '@/UI/components/Helpers/ProxyDataForm'
import {checkUserRole, getUserData} from '@/router/Lib/helper';
import {CounterpartiesMix} from '@/UI/mixins/CounterpartiesMix';
import {ProxyTableData} from "@/UI/components/Helpers/ProxyTableData";
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import {appPaginationStore} from "@/store/modules/appPagination";
import {getStudioId} from "@/UI/lib/state";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"

@Component({
  components: {ModalWrapper, PageTitle, CounterpartiesAddComponent, CounterpartiesUpdateComponent, SortComponent}
})
export default class Counterparties extends mixins(ProxyTableData, CounterpartiesMix, ProxyGetData) {
  form = new CounterpartiesAddForm();
  updateForm = new CounterpartiesUpdateForm();
  // counterparty: ICounterpartiesListItem | null = null;
  searchText = '';
  searchInput: null;
  searchedColumn = '';
  showAddModal = false;
  showUpdateModal = false;
  filterData: any;
  fileList: any = [];
  importFile: any = null;
  uploading: boolean = false;

  constructor() {
    super();
  }

  customRow = (record: any) => {
    return {
      on: {
        click: (event: any) => {
          //this.$router.push({name: RouterNameEnum.SalonDetail, params: {id: record.id}})
        }
      }
    };
  }

  async created(): Promise<void> {
    try {
      //await CounterpartiesStore.fetchAll({limit: this.AppPageParams.pageSize})
      //await this.fetch();
      this.proxyFilter = {
        salon_id: getStudioId(this),
      }
      appPaginationStore.setCurrent(1)
      await this.sortedData('desc', {dataIndex: 'created_at'})
      await this.fetchModules([
        {s: 'category', p: {limit: -1}}
      ])
      await this.createProxy();
    } catch (e) {
      console.log(e)
    } finally {
      this.tableLoad = true;
    }
  }

  get columns(): ITableColumn[] {
    return TablesStore.financeCounterparties;
  }

  // get counterparties(): ICounterparties | null {
  //   return CounterpartiesStore.counterparties;
  // }

  async handleAddModal(visible: boolean): Promise<void> {
    if (visible) {
      let studio_id = this.form.setFormData(await this.counterpartiesTypes());
    }
    this.showAddModal = visible;
  }

  async handleUpdateModal(visible: boolean): Promise<void> {
    this.showUpdateModal = visible;

    if (visible) {
      this.updateForm.setFormData(this.counterparty, await this.counterpartiesTypes());
    }
  }

  async show(counterparty: ICounterpartiesListItem) {
    this.updateForm.setFormData(counterparty, await this.counterpartiesTypes());
    this.handleUpdateModal(true);
    // this.visible = true;
  }

  async submit(): Promise<void> {
    if (checkUserRole() == 'owner') {
      const userData = getUserData();
      this.form.salon_id = userData.studios;
    } else if (this.$store.state.salon_id) {
      this.form.salon_id = this.$store.state.salon_id;
    }
    if (await this.form.submit(CounterpartiesStore.create)) {
      //this.fetchTableItems();
      await this.createProxy();
      this.showAddModal = false;
      this.form = new CounterpartiesAddForm();
    }
  }

  async updateSubmit(): Promise<void> {
    if (await this.updateForm.submit(CounterpartiesStore.update)) {
      //this.fetchTableItems();
      await this.createProxy();
      this.showUpdateModal = false;
      // if(this.counterparties && this.counterparties.data){
      //   if(this.counterparty){
      //     for(let i = 0; i < this.counterparties.data.length; i++){
      //       if(this.counterparty.id == this.counterparties.data[i].id){
      //         // this.counterparty = this.counterparties.data[i];
      //         break;
      //       }
      //     }
      //   }
      // }
      this.updateForm = new CounterpartiesUpdateForm();
    }
  }

  async handleSearch(selectedKeys: any, confirm: any, dataIndex: string) {
    //confirm();
    const Role = checkUserRole();
    const UserData = getUserData();

    if (selectedKeys && selectedKeys.length) {
      this.searchText = selectedKeys[0];
    } else {
      this.searchText = '';
    }

    const filter = new (class {
      salon_id: number | null;
      name: string | null;

      constructor(name: string) {
        this.salon_id = null;
        this.name = name;
      }
    })(this.searchText);

    if (Role == 'owner' && UserData && UserData.studios) {
      filter.salon_id = UserData.studios;
    } else if (this.$store.state.salon_id) {
      filter.salon_id = this.$store.state.salon_id;
    }

    await this.$store.dispatch('counterparties' + '/fetchAll', {
      limit: this.AppPageParams.pageSize,
      filter: filter,
    });

  }

  async handleReset(clearFilters: any): Promise<void> {
    this.searchText = '';
    const Role = checkUserRole();
    const UserData = getUserData();

    const filter = new (class {
      salon_id: number | null;
      name: string | null;

      constructor(name: string) {
        this.salon_id = null;
        this.name = name;
      }
    })(this.searchText);

    if (Role == 'owner' && UserData && UserData.studios) {
      filter.salon_id = UserData.studios;
    } else if (this.$store.state.salon_id) {
      filter.salon_id = this.$store.state.salon_id;
    }


    await this.$store.dispatch('counterparties' + '/fetchAll', {
      limit: this.AppPageParams.pageSize,
      filter: filter,
    });
    clearFilters();
  }

  async counterpartiesTypes(data?: Record<string, any>): Promise<ICounterpartiesType[]> {
    if (!CounterpartiesTypeStore.items) {
      await CounterpartiesTypeStore.fetchAll();
    }

    if (CounterpartiesTypeStore.items) {
      return CounterpartiesTypeStore.items;
    } else {
      return [];
    }
  }

  handleImportFileChange(info: any): void {
    /*if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      this.$message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.$message.error(`${info.file.name} file upload failed.`);
    }*/
  }

  beforeUpload(file: any): boolean {
    this.uploading = true;
    this.importFile = file;
    this.fileList = [file];
    this.confirmUploadFile();
    return false;
  }

  async uploadFile(): Promise<void> {
    let res = await CounterpartiesStore.import(this.importFile);
    if (res) {
      if (res.status) {
        //await this.fetchTableItems();
        await this.createProxy();
        this.$message.success(res.response);
        // this.setPaginationTotal();
      } else {
        this.$message.error(res.response);
      }
    }
    this.uploading = false;
  }

  async downloadFile(): Promise<void> {
    let res = await CounterpartiesStore.export();
    if (res && !res.status) {
      this.$message.error(res.response);
    } else {
      let fileUrl = res.response;
      var fileLink = document.createElement('a');

      fileLink.href = fileUrl;
      fileLink.setAttribute('download', 'file.pdf');
      document.body.appendChild(fileLink);

      fileLink.click();
      fileLink.remove();
    }
  }

  confirmUploadFile(): void {
    if (window.confirm(i18nText("Файл готов к загрузке. Продолжить загрузку?"))) {
      this.uploadFile();
    } else {
      this.uploading = false;
      this.fileList = [];
      this.importFile = null;
    }
  }

  triggerUpload(): void {
    let elem = this.$refs.uploadEvent;
    if (elem && '$el' in elem) {
      elem.$el?.querySelector('input')?.click();
    }
  }

  async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
    await this.sortedData(by, {dataIndex: sort.dataIndex})
  }
}
